var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InstanceDropdown,{attrs:{"prefix":"object-store","name":_vm.objectStore.name || '',"is-upgradable":_setup.isUpgradable,"route-upgrade":_setup.routeUpgrade,"route-edit":_setup.routeEdit},on:{"test":function($event){return _setup.emit('test')},"remove":_setup.onRemove}})
}
var staticRenderFns = []

export { render, staticRenderFns }